import { Injectable } from '@angular/core';

@Injectable()
export abstract class CalibrationStatementPopup {
    abstract OpenCalibrationStatementPopup(): void;
}